import PropTypes from 'prop-types';
import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const IconFilters = ({ className, fill }) => {

    return (
        <svg
            className={'icon-filters' + (className ? ` ${className}` : '')}
            fill='none'
            viewBox='0 0 18 18'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M0 4h18M0 9h18M0 14h18'
                stroke='#333332' />
            <rect
                fill='none'
                height='4'
                rx='1'
                stroke={fill || '#333332'}
                width='2'
                x='5'
                y='2' />
            <rect
                fill='none'
                height='4'
                rx='1'
                stroke={fill || '#333332'}
                width='2'
                x='12'
                y='7' />
            <rect
                fill='none'
                height='4'
                rx='1'
                stroke={fill || '#333332'}
                width='2'
                x='5'
                y='12' />
        </svg>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    className: PropTypes.string,
    fill: PropTypes.string
};

IconFilters.propTypes = propTypes;

export default IconFilters;
